module.exports = __webpack_public_path__ + "img/10800.d77f824b.jpg";